import { render, staticRenderFns } from "./ProblemFeedback.vue?vue&type=template&id=b69e9580&scoped=true&"
import script from "./ProblemFeedback.vue?vue&type=script&lang=js&"
export * from "./ProblemFeedback.vue?vue&type=script&lang=js&"
import style0 from "./ProblemFeedback.vue?vue&type=style&index=0&id=b69e9580&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b69e9580",
  null
  
)

export default component.exports